import { environment } from "environment/environment";

const SESSION_ID_KEY = "stockApiUserSchedulerSessionId";

const createSessionId = () => {
  if (typeof window.crypto?.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const getOrCreateUserSchedulerSessionId = () => {
  const existing = sessionStorage.getItem(SESSION_ID_KEY);
  if (existing) return existing;

  const sessionId = createSessionId();
  sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  return sessionId;
};

export const getUserSchedulerSessionId = () =>
  sessionStorage.getItem(SESSION_ID_KEY);

const postPresence = async (operation, accessToken, sessionId) => {
  if (!accessToken) {
    throw new Error("Index API login token is missing");
  }

  const params = new URLSearchParams({ sessionId });
  const response = await fetch(
    `${environment.userSchedulerPresenceBaseUrl}/${operation}?${params}`,
    {
      method: "POST",
      keepalive: operation === "logout",
      headers: { Authorization: `Bearer ${accessToken}` },
    }
  );

  if (!response.ok) {
    const error = new Error(
      `User scheduler ${operation} failed with status ${response.status}`
    );
    error.status = response.status;
    throw error;
  }
};

export const heartbeatUserSchedulerSession = (accessToken, sessionId) =>
  postPresence("heartbeat", accessToken, sessionId);

export const stopUserSchedulerSession = (accessToken, sessionId) =>
  postPresence("logout", accessToken, sessionId);
